module.exports = __webpack_public_path__ + "img/admin.7d241efe.png";